/** 渠道包状态 */
module.exports = () => {
  return {
    CHANNEL_PACKAGE_STATUS_PASSED: '审核通过',
    CHANNEL_PACKAGE_STATUS_REVIEWING: '审核中',
    CHANNEL_PACKAGE_STATUS_DENIED: '审核拒绝',
    CHANNEL_PACKAGE_STATUS_DENIED_AGAIN: '审核拒绝，使用更新前的数据',
    CHANNEL_PACKAGE_STATUS_REVIEWING_AGAIN: '再次审核中',
    CHANNEL_PACKAGE_STATUS_ON_OFFLINE: '下线中',
    CHANNEL_PACKAGE_STATUS_OFFLINE: '下线',
    CHANNEL_PACKAGE_STATUS_DRAFT: '草稿',
  };
};

